import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import * as shapes from '../../shapes';
import List from './List';

const ServiceList = ({ services, selectedServices, addItem }) => {
  if (isEmpty(services)) {
    return (
      <p className="u-text-center u-mb-auto">
        There are no services added, please add services first.
      </p>
    );
  }
  return (
    <List
      items={services}
      selectedItems={selectedServices}
      addItem={addItem}
      color="yellow"
    />
  );
};
ServiceList.propTypes = {
  services: shapes.services,
  selectedServices: PropTypes.arrayOf(PropTypes.string),
  addItem: shapes.handler,
};
ServiceList.defaultProps = {
  services: [],
  selectedServices: [],
  addItem: () => null,
};

export default ServiceList;
